import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { get, post } from "../api";
import { useI18n } from "../i18n";

interface Me {
  email: string;
  workspaces: { id: string; name: string; capabilities: string[] }[];
}

export function WorkspacesPage({ me }: { me: Me }) {
  const { t } = useI18n();
  const [name, setName] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [reload, setReload] = useState(0);
  const [list, setList] = useState(me.workspaces);

  useEffect(() => {
    get<{ items: typeof list }>("/api/v1/workspaces").then((r) => setList(r.items));
  }, [reload]);

  return (
    <>
      <h2>{t.workspaces.title}</h2>
      <div className="card">
        {list.length === 0 && <p className="muted">{t.workspaces.empty}</p>}
        <table>
          <thead>
            <tr>
              <th>{t.workspaces.tableHeaderName}</th>
              <th>{t.workspaces.tableHeaderCapabilities}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {list.map((w) => (
              <tr key={w.id}>
                <td>{w.name}</td>
                <td className="muted">{w.capabilities.join(", ")}</td>
                <td><Link to={`/w/${w.id}`}>{t.common.open}</Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="card">
        <h3>{t.workspaces.createTitle}</h3>
        <div className="row">
          <input
            value={name}
            placeholder={t.workspaces.namePlaceholder}
            onChange={(e) => setName(e.target.value)}
          />
          <button
            className="primary"
            style={{ maxWidth: 120 }}
            onClick={async () => {
              setErr(null);
              try {
                await post("/api/v1/workspaces", { name });
                setReload((n) => n + 1);
                setName("");
              } catch (e) {
                setErr((e as Error).message);
              }
            }}
          >
            {t.common.create}
          </button>
        </div>
        {err && <p className="error">{err}</p>}
      </div>
    </>
  );
}
